howspace.transcript = (() => {
    'use strict';

    const showContent = elem => {
        howspace.animate(elem, 'slideDown', 350, () => {
            elem.removeAttr('style').removeClass('d-none');
        });
    }

    const hideContent = elem => {
        howspace.animate(elem, 'slideUp', 350, () => {
            elem.removeAttr('style').addClass('d-none');
        });
    }

    const editTranscript = e => {
        hideContent($(e.target).closest('.transcript-container').find('.transcript-view-content'));
        showContent($(e.target).closest('.transcript-container').find('.transcript-edit-content'));
        showContent($(e.target).closest('.transcript-container').find('.synopsis-edit-content'));
    }

    const cancelEditTranscript = e => {
        showContent($(e.target).closest('.transcript-container').find('.transcript-view-content'));
        hideContent($(e.target).closest('.transcript-container').find('.transcript-edit-content'));
        hideContent($(e.target).closest('.transcript-container').find('.synopsis-edit-content'));
    }

    const saveTranscript = e => {
        const btn = $(e.target);
        const container = btn.closest('.transcript-container')
        const reTranscribeLanguage = container.find('.transcript-re-transcribe-language').val();
        const payload = real.form.getDataPayload(container);
        real.button.loading(btn);

        if (reTranscribeLanguage) {
            real.ajax.json(real.baseUri + '/api/transcribe/queue', {
                type: 'POST',
                data: JSON.stringify({
                    id: btn.data('id'),
                    language: reTranscribeLanguage,
                }),
                success: () => {
                    hideContent(container.find('.transcript-content-wrapper'));
                    showContent(container.find('.transcript-progress-wrapper'));
                    real.button.reset(btn);
                },
                error: () => console.log('error'),
            });
        } else {
            real.ajax.json(real.baseUri + '/uploadedfile/' + btn.data('id') + '/update-transcript',
                {
                    type: 'POST',
                    data: JSON.stringify(payload),
                    success: response => {
                        real.button.reset(btn);
                    }
                }
            );
        }
    }

    const reTranscribeLanguage = e => {
        const select = $(e.target);
        const container = select.closest('.transcript-container');
        const editor = container.find('.transcript-edit-text');

        // Set contentEditable to false
        if (select.val()) {
            editor.attr('contentEditable', false);
        } else {
            editor.attr('contentEditable', true);
        }
    }

    const processTimestamps = transcript => {
        const tsRex = /\[((?:\d{2}:)?\d{2}:\d{2})]/;
        transcript.find('.transcript-text').contents().each((_, e) => {
            let $e = $(e);

            const match = tsRex.exec($e.text());
            if (match === null) {
                return;
            }

            const ts = match[1];
            const secs = _toSecs(ts);

            // Check if the timestamp was found in a plain text node, i.e. if
            // the transcript was manually edited after simple text editor was
            // updated to delete divs.
            if (e.nodeType === 3) {
                $e = $e.wrap('<div style="display: inline-block;" />').parent();
            }

            $e.addClass('t_ts');
            $e.text(ts);
            $e.on('click', (event) => setVideoPos(event.target, secs));
        });
    }

    const _toSecs = dur => {
        const parts = dur.split(':').reverse();
        if (parts.length !== 2 && parts.length !== 3) { return 0; }
        let seconds = 0;
        for (const i in parts) {
            seconds += parts[i] * Math.pow(60, i);
        }
        return seconds;
    }

    const setVideoPos = (caller, secPos) => {
        const videoContainer = $(caller).closest('.transcript-container').prev();

        if (videoContainer.length === 0 || !videoContainer.is('.howspace-video-player')) {
            return;
        }

        const isPlaying = videoContainer.is('.playing');
        if (!isPlaying) {
            videoContainer.dataAndAttr('start-at-seconds', secPos);
            videoContainer.find('.play-button').trigger('click');
        } else {
            const vjs = videojs(videoContainer.find('.video-js')[0]);
            vjs.currentTime(secPos);
        }
    }

    return {
        init: (elem) => {
            elem.find('.transcript-edit-btn').on('click', editTranscript)
            elem.find('.cancel-transcript-edit-btn').on('click', cancelEditTranscript);
            elem.find('.save-transcript-edit-btn').on('click', saveTranscript);
            elem.find('.transcript-re-transcribe-language').on('change', reTranscribeLanguage);

            processTimestamps(elem);

            elem
                .find('.transcript-text.translatable')
                .each((_, tEle) =>
                    howspace.components.translator.setCallback(
                        tEle.dataset.t9nType,
                        tEle.dataset.t9nId,
                        tEle.dataset.t9nAttr,
                        (ele) => processTimestamps($(ele).closest('.transcript-container')),
                    ));
        },

        destroy: (elem) => {
            elem.find('.transcript-edit-btn').off('click', editTranscript);
            elem.find('.cancel-transcript-edit-btn').off('click', cancelEditTranscript);
            elem.find('.save-transcript-edit-btn').off('click', saveTranscript);
            elem.find('.transcript-re-transcribe-language').off('change', reTranscribeLanguage);
        }
    };
})();
